export const Crossroads = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 30V2" stroke="currentColor" stroke-width="2"/>
<path d="M16 13H25.1704C25.4359 13 25.6905 12.8944 25.8781 12.7065L28.5801 10L25.8781 7.29349C25.6905 7.10559 25.4359 7 25.1704 7H16" stroke="currentColor" stroke-width="2"/>
<path d="M16 19H6.82959C6.56408 19 6.30947 18.8944 6.12189 18.7065L3.41994 16L6.12189 13.2935C6.30947 13.1056 6.56408 13 6.82959 13H16" stroke="currentColor" stroke-width="2"/>
</svg>`;
